const normalizeApiBase = (url) => {
  const trimmedUrl = (url || 'http://localhost:3000/api/v1').trim().replace(/\/+$/, '')
  return trimmedUrl.endsWith('/api/v1') ? trimmedUrl : `${trimmedUrl}/api/v1`
}

export const API_BASE = normalizeApiBase(import.meta.env.VITE_API_URL)

const getAuthHeaders = () => {
  const token = localStorage.getItem('inflynx_token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

const parseResponse = async (response) => {
  if (response.ok) return response.json()

  let message = 'Request failed'
  try {
    const data = await response.json()
    if (Array.isArray(data.message)) {
      message = data.message.join(', ')
    } else if (data.message) {
      message = data.message
    }
  } catch {
    // ignore parse errors
  }

  throw new Error(message)
}

export const api = {
  async login(email, password) {
    const response = await fetch(`${API_BASE}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    })
    return parseResponse(response)
  },

  async signup(email, password, name) {
    const response = await fetch(`${API_BASE}/auth/signup`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password, name }),
    })
    return parseResponse(response)
  },

  async createDeviceCode(code) {
    const response = await fetch(`${API_BASE}/auth/device-code`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code }),
    })
    return parseResponse(response)
  },

  async getDeviceCodeStatus(code) {
    const response = await fetch(`${API_BASE}/auth/device-code/${code}/status`, {
      headers: { 'Content-Type': 'application/json' },
    })
    return parseResponse(response)
  },

  async getMe() {
    const response = await fetch(`${API_BASE}/auth/me`, {
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    })
    return parseResponse(response)
  },

  async getProfile() {
    const response = await fetch(`${API_BASE}/users/profile`, {
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    })
    return parseResponse(response)
  },

  async getStats() {
    const response = await fetch(`${API_BASE}/users/stats`, {
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    })
    return parseResponse(response)
  },

  async getProjects() {
    const response = await fetch(`${API_BASE}/projects`, {
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    })
    return parseResponse(response)
  },

  async getDeployments() {
    const response = await fetch(`${API_BASE}/deployments`, {
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    })
    return parseResponse(response)
  },
}
